export default __webpack_public_path__ + "static/media/wilson.98a16c39.png";